import { getBeaconLocationIds } from '@esentai/core/features/beacons/selectors';
import { connect } from 'react-redux';

import StatusLabel from './component';

const mapStateToProps = (state, { itemId }) => ({
  locationsIds: getBeaconLocationIds(state, itemId),
});

export default connect(mapStateToProps)(StatusLabel);
